<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
    <div>

        <!-- https://newmy.muic.io/smartauthenqr?token_event=ABprhk&token_key=53O517527UC4W19873PH9#state=c6d1b8d8-d601-42b9-a44f-dd2c87211d81&session_state=d65ccac0-da74-4bd2-9025-95723390af7f&code=013429da-315d-4937-8881-26dab01d7e70.d65ccac0-da74-4bd2-9025-95723390af7f.7b8892cc-cb3c-4a96-b374-2b23a7cdbd3f -->

        <!-- reset Up Form -->
        <div class="card-center">
            <a-card v-if="Object.keys(dataEvent).length != 0" hoverable style="width: 300px">


                <img slot="cover" alt="imag_smartauthenqr_1" src="../../../public/images/meetingRoom.png" />
                <template slot="actions" class="ant-card-actions">
                    <div style="padding: 10px;">

                        <div v-if="canJoin(dataEvent.start_date, dataEvent.end_date)">
                            <a-button
                                :disabled="dataEvent.idJoin.includes(`${this.$store.state.role.RulesUser.codeId}`) || countdown === 0"
                                size="sm" type="primary" block @click="checkinByQr()">
                                Join Event in {{
                                    !dataEvent.idJoin.includes(`${this.$store.state.role.RulesUser.codeId}`) ?
                                        `${countdown}s` : '' }}
                            </a-button>
                        </div>
                        <div v-else>
                            <a-alert type="error" message="TimeOut : Event นี้ได้จบลงไปแล้ว" banner />
                        </div>
                        <small v-if="msgCheckIns !== ''">{{ msgCheckIns }}</small>
                    </div>
                </template>
                <a-card-meta>
                    <template slot="title">
                        <p style="font-size: 18px;" class="mt-0 mb-0 font-web"><span v-html="dataEvent.name"></span></p>
                    </template>
                    <template slot="description">
                        <p class="mt-0 mb-0 font-web">
                            <a-icon class="mr-5" type="calendar" />{{ moment(dataEvent.start_date).format('DD / MM / YYYY') }}
                        </p>
                        <p class="mt-0 mb-0 font-web">
                            <a-icon class="mr-5" type="clock-circle" />{{
                                moment(dataEvent.start_date).format('HH:mm:ss') }} - {{
                                moment(dataEvent.end_date).format('HH:mm:ss') }}
                        </p>
                    </template>
                </a-card-meta>
                <a-card-meta class="mt-30" :title="fullName">
                    <a-avatar shape="square" slot="avatar" :src="picture" />
                </a-card-meta>
            </a-card>
        </div>
        <div class="text-center mt-20">
            <p :style="{ fontSize: '10px' }" class="mt-0 mb-0 font-web font-weight-bold">
                พบปัญหาอื่นๆ สามารถติดต่อมายัง
            </p>
            <p :style="{ fontSize: '10px' }" class="mt-0 mb-0 font-web font-weight-bold">email
                &nbsp;&nbsp;&nbsp;&nbsp;<strong><a :style="{ fontSize: '12px' }"
                        href="mailto:ic-inhouse@mahidol.edu">ic-inhouse@mahidol.ac.th</a></strong> </p>
        </div>
        <!-- / reset Up Form -->

    </div>
</template>

<script>
import authService from '@/services/authService';

export default ({
    data() {
        return {
            loadingMainUi: false,
            dataEvent: {},
            statusRes: '',
            loadStatus: false,
            textMsg: `Your ${this.$keycloak.fullName} identity has been successfully verified by the system. Please log in to access the application again`,
            fullName: '',
            picture: '',
            // 
            loadiingCheck: false,
            // 
            countdown: 0,
            timer: null,
            // 
            msgCheckIns: '',
        }
    },
    beforeCreate() { },
    computed: {
        getUrlPath() {
            let fullLink = ''
            let url = this.$route.fullPath
            if (url.split('#').length > 1) {
                fullLink = url.split('#')[0].replace('https://newmy.muic.io/smartauthenqr?', '')
                return this.getTokensFromURL(fullLink, 'event')
            } else {
                return this.$route.query.token_event === undefined ||
                    this.$route.query.token_event === ""
                    ? "Not spectify {{token_event}}"
                    : this.$route.query.token_event;
            }
        },
        getTokenPath() {
            let fullLink = ''
            let url = this.$route.fullPath
            if (url.split('#').length > 1) {
                fullLink = url.split('#')[0].replace('https://newmy.muic.io/smartauthenqr?', '')
                return this.getTokensFromURL(fullLink, 'token_key')
            } else {
                return this.$route.query.token_key === undefined ||
                    this.$route.query.token_key === ""
                    ? "Not spectify {{token_key}}"
                    : this.$route.query.token_key;
            }
        },
    },
    mounted() {
        if (this.$route.query.token_event !== undefined || this.$route.query.token_event !== "") {
            this.startCountdown()
            this.getEventByToken()
            if (this.$store.state.role.RulesUser.roles.includes("student")) {
                this.getStudentProfile();
            } else {
                this.getBaseProfile();
            }
        }
    },
    beforeDestroy() {
        if (this.timer) clearInterval(this.timer)
    },
    methods: {
        getTokensFromURL(queryString, val) {
            const params = new URLSearchParams(queryString)
            const token_event = params.get('token_event')
            const token_key = params.get('token_key')
            return val === 'event' ? token_event : token_key
        },
        // 
        startCountdown() {
            this.countdown = 30
            if (this.timer) clearInterval(this.timer)
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--
                } else {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 1000)
        },
        // 
        checkDataRender(val, obj) {
            return Object.keys(val).length === 0 ? "-" : val[obj];
        },
        getDataJoin(data) {
            let arr = []
            for (const item of data.attendees) {
                arr.push(item.user_id.toString())
            }
            return arr
        },
        async getEventByToken() {
            this.countData = 0
            this.loadingMainUi = true
            try {
                const res = await this.$http.get(
                    `/smart-authen/event/${this.getUrlPath}/now/`,
                );
                if (res.status === 200) {
                    this.loadingMainUi = false
                    this.dataEvent = { ...res.data };
                    this.dataEvent = {
                        ...this.dataEvent,
                        'idJoin': this.getDataJoin(res.data)
                    };
                    console.log(this.dataEvent)
                } else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                this.dataEvent = {}
                this.loadingMainUi = false
                this.handleErrorCase(
                    error.response.status,
                    `/smart-authen/event/${this.getUrlPath}/now/`
                );
            }
        },
        async getBaseProfile() {
            try {
                const msalToken = await authService.getAccessToken();
                const resBaseProfile = await this.$http.get(`/staff/profile/me/`, {
                    headers: {
                        Authorization: `Bearer ${msalToken}`
                    }
                });
                if (resBaseProfile.status === 200) {
                    this.fullName = `${resBaseProfile.data.title.name_eng} ${resBaseProfile.data.name} ${resBaseProfile.data.surname}`;
                    this.picture = resBaseProfile.data.img;
                } else {
                    const error = new Error('API Error');
                    error.resBaseProfile = resBaseProfile;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue connect api : /staff/profile/me/`,
                });
            }
        },
        async getStudentProfile() {
            try {
                const msalToken = await authService.getAccessToken();
                const resStudent = await this.$http.get(`/student/profile/me/`, {
                    headers: {
                        Authorization: `Bearer ${msalToken}`
                    }
                });
                if (resStudent.status === 200) {
                    this.fullName = `${resStudent.data.title} ${resStudent.data.english_first_name} ${resStudent.data.english_last_name}`;
                    this.picture =
                        "https://icapp.muic.mahidol.ac.th/source/pic/" +
                        resStudent.data.id +
                        ".jpg";
                } else {
                    const error = new Error('API Error');
                    error.resStudent = resStudent;
                    throw error;
                }
            } catch (error) {
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue connect api : /student/profile/me`,
                });
            }
        },
        canJoin(startDate, endDate) {
            const now = this.moment(); // เวลาปัจจุบัน
            return this.moment(startDate).isBefore(now) && this.moment(endDate).isAfter(now);
        },
        // 
        async checkinByQr() {
            this.msgCheckIns = ''
            this.loadiingCheck = true
            try {
                const msalToken = await authService.getAccessToken();
                const sendData = new FormData();
                sendData.append("old_event", this.getUrlPath);
                sendData.append("token_key", this.getTokenPath);
                const res = await this.$http.post(
                    "/smart-authen/check-in/by-qr/",
                    sendData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: `Bearer ${msalToken}`
                        },
                    }
                );
                if ([200, 201, '200', '201'].includes(res.status)) {
                    this.dataEvent.idJoin.push(`${res.data.joiner}`)
                    this.msgCheckIns = 'Success checkIns'
                    this.$notification.open({
                        style: {
                            backgroundColor: "#A0C878",
                            color: "#ffffff",
                        },
                        message: function (h) {
                            return h("div", [h("strong", { class: "" }, `Success`)]);
                        },
                        description: `Checkins : event`,
                        duration: 0,
                    });
                }
                else {
                    const error = new Error('API Error');
                    error.res = res;
                    throw error;
                }
            } catch (error) {
                console.log(error.response.data.detail)
                this.loadiingCheck = false
                this.msgCheckIns = `!!! ${error.response.data.detail} !!!`
                this.$notification.open({
                    style: {
                        backgroundColor: "#ff1919",
                        color: "#ffffff",
                    },
                    message: function (h) {
                        return h("div", [h("strong", { class: "" }, `Error`)]);
                    },
                    description: `Promblem issue connect api : /smart-authen/check-in/by-qr/`,
                    duration: 0,
                });
            }
        }
    },
})

</script>

<style scoped>
.card-center {
    margin-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>